import api from 'api';

export const loadTags = api('GET /api/conversion-pages-tags/list');

export const createTag = api('POST /api/conversion-pages-tags');

export const updateTag = api('PUT /api/conversion-pages-tags/:id');

export const deleteTag = api('DELETE /api/conversion-pages-tags/:id');

export const batchAddTag = api('POST /api/conversion-pages-tags/batch-add');
